module.exports = "https://www.gc-qa.gnp.com.mx/6fe5061b68c4014e175f9e7c3f00ca38.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/googleplus.png
// module id = 8110
// module chunks = 0